var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37256 24 0 18.6274 0 12C0 5.37256 5.37256 0 12 0C18.6274 0 24 5.37256 24 12ZM17.9489 9.30111C18.3913 8.80766 18.3499 8.04899 17.8564 7.60658C17.363 7.16417 16.6043 7.20555 16.1619 7.69901L10.6407 13.8573L7.54773 11.1038C7.05273 10.6631 6.29421 10.7071 5.85353 11.2021C5.41285 11.6972 5.4569 12.4557 5.9519 12.8963L10.8312 17.2401L17.9489 9.30111Z",
    fill: "#f50400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIconRed);
export default __webpack_public_path__ + "static/media/complete-icon-red.9bb4ecb5bbcab833893d7138d785c486.svg";
export { ForwardRef as ReactComponent };